import Swiper from 'swiper';
class ComparisonCarousel {
    constructor(container, numberSlides, desktopCount, mobileCount) {
        this.swipers = null;
        this.slides = 0;
        // Best window width max values to add the swiper. This values are also in the tiles.scss.
        // 706px/16px;
        this.twoColumnsMaxmimumWidthInEms = 44.125;
        // 1023 / 16px
        this.threeColumnsMaxmimumWidthInEms = 63.9375;
        // 1376 / 16px
        this.fourColumnsMaxmimumWidthInEms = 86;
        this.switchTab = (tab) => {
            const tabId = tab.dataset.tab;
            const tabContent = this.container.querySelector(`.comparison-carousel__content[data-tab="${tabId}"]`);
            const tabContentActive = this.container.querySelector('.comparison-carousel__content--active');
            const tabActive = this.container.querySelector('.comparison-carousel__tabs-tab--active');
            if (tabActive.dataset.tab === tabId) {
                return;
            }
            if (tabContent && tabContentActive && tabActive) {
                tabContent.classList.add('comparison-carousel__content--active');
                tabContentActive.classList.remove('comparison-carousel__content--active');
                tab.classList.add('comparison-carousel__tabs-tab--active');
                tabActive.classList.remove('comparison-carousel__tabs-tab--active');
            }
        };
        this.addSwiper = () => {
            if (!this.swipers) {
                this.swipers = [];
                this.swiperContainers.forEach((swiperContainer) => {
                    this.swipers.push(new Swiper(swiperContainer, {
                        grabCursor: true,
                        mousewheel: false,
                        observer: true,
                        observeParents: true,
                        scrollbar: {
                            el: '.swiper-scrollbar',
                            hide: false,
                        },
                        navigation: false,
                        spaceBetween: 20,
                        breakpoints: {
                            0: {
                                slidesPerView: 1,
                            },
                            576: {
                                slidesPerView: 2,
                            },
                            768: {
                                slidesPerView: 4,
                            },
                            1200: {
                                slidesPerView: 6,
                            },
                        },
                    }));
                });
            }
        };
        this.destroySwiper = () => {
            if (this.swipers) {
                this.swipers.forEach((swiper) => {
                    swiper.destroy();
                });
                this.swipers = null;
            }
        };
        this.slides = numberSlides;
        this.desktopCount = desktopCount;
        this.mobileCount = mobileCount || 1;
        this.swiperContainers = container.querySelectorAll('.comparison-carousel__content-wrapper');
        this.tabs = container.querySelectorAll('.comparison-carousel__tabs-tab');
        this.container = container;
        this.addSwiper();
        this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                this.switchTab(tab);
            });
        });
    }
}
export default ComparisonCarousel;
